import React, { useEffect, useState } from 'react'
import image from "../../rels_assets/images/blog/b-11.jpg"
import PropertyListBlock from '../common/Property/propertyListBlock';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHotPropertyRequest, fetchPropertiesByFilterRequest, setSelectedOptionsRequest } from '../Landing/actions';
import $, { data } from 'jquery'
import { useHistory } from "react-router-dom"
import { getQueryString } from '../../helper';

const FeaturedProperties = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [hotproperties, setProperty] = useState([]);

  const property = useSelector(store => store.landingPageData.hotPropertyData.length > 0 ? store.landingPageData.hotPropertyData : store.landingPageData.hotPropertyData)
  const initialOptions = useSelector(store => store.landingPageData.selectedOptions > 0 ? store.landingPageData.selectedOptions : store.landingPageData.selectedOptions)
  const allSelectedOption = useSelector(store => store.landingPageData.selectedOptions);
  useEffect(() => {
    loadData();
  }, []);
  useEffect(() => {
    /** setProducts..! */
    if (typeof property.data === 'object' && Object.keys(property.data).length > 0) {
      setProperty(property.data)
    }
  }, [property])

  /** Custom function */
  function loadData() {
    dispatch(fetchHotPropertyRequest(JSON.stringify([data])))
  }

  const handleClick = (event) => {
    if (event.type === 'click') {
      initialOptions.hot_property = true;
      let QueryString = "";
      dispatch(setSelectedOptionsRequest(initialOptions));
      if (typeof initialOptions === 'object' && Object.keys(initialOptions).length > 0) {
        // dispatch the properties list by selected filter options..
        QueryString = getQueryString(initialOptions);
        dispatch(fetchPropertiesByFilterRequest(JSON.stringify(initialOptions)))
      }
      history.push({
        pathname: '/hot-property',
        search: `?${QueryString}`
      })
    }
  }


  return (
    <>
      {/* <!-- START SECTION FEATURED PROPERTIES --> */}
      {
        hotproperties && hotproperties.length > 0 &&

        <section className=' featured portfolio blog bg-white-2'>
          <div className='container container-header'>
            <div className="sec-title">
              <h2><span>Hot Properties</span></h2>
            </div>
            <div className='row featured portfolio-items justify-content-center'>
              {
                hotproperties.slice(0, 4).map((item, index) => {
                  return (
                    <React.Fragment key={`hotproperties-${index}`}> <PropertyListBlock property={item} columnClass="col-xl-3 col-lg-3 col-md-6 col-xs-12" /></React.Fragment>
                  )
                })
              }
            </div>
            {
              hotproperties.length > 4 &&
              <div className="bg-all">
                <button className="btn btn-outline-light" onClick={handleClick} >View More</button>
              </div>
            }

          </div>

        </section>
      }

      {/* <section className="featured portfolio bg-white-2 rec-pro full-l">
          <div className="container-fluid">
            <div className="sec-title">
              <h2><span>Hot Properties</span></h2>
            </div>
            <div className="row portfolio-items">
              {
                hotproperties.map((item, index) => {
                  return (
                    <React.Fragment key={`hotproperties-${index}`}> <PropertyListBlock property={item} columnClass="col-xl-6 col-lg-12 col-md-12 col-xs-12 " columnClass2={'card-margin'} /></React.Fragment>
                  )
                })
              }
            </div>
            {
              hotproperties.length > 6 &&
              <div className="bg-all">
                <button className="btn btn-outline-light" onClick={handleClick} >View More</button>
              </div>
            }
          </div>
        </section> */}
      {/* <!-- END SECTION FEATURED PROPERTIES --> */}
      {/* <p>These are our hot properties</p> */}

    </>
  )
}

export default FeaturedProperties
